import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CommonDashboardWrapper } from "styles/GlobalStyles";
import {
  CardFlexWrapperStyles,
  CardWrapperStyles,
  TableWrapperStyles
} from "pages/TalentUploadRequest/styled";

import { selectRosterRequests } from "pages/TalentUploadRequest/slice/selector";
import { useRosterImportSlice } from "pages/TalentUploadRequest/slice";

import CommonTable from "components/Tables/CommonTable";
import columns from "pages/TalentUploadRequest/column";
import PillButtons from "components/Buttons/PillButtons";

import {
  DotOutlineFillIcon,
  RightIconOutlineRegularIcon
} from "assets/SVGComponents/index";

import SkeletonLoader from "components/PageLoader/SkeletonLoader";
import Icon from "components/Icon/Icon";
import { DotIcon, CaretDownIcon } from "@phosphor-icons/react";
import UpdateRosterStatusModal from "components/Modal/UpdateRosterStatusModal/index";

const TalentUploadRequest = () => {
  const dispatch = useDispatch();
  const { actions } = useRosterImportSlice();
  const {
    loading,
    initialLoading,
    total_count,
    completed_requests,
    pending_requests,
    rosters,
    pagination
  } = useSelector(selectRosterRequests);

  const [selectedStatus, setSelectedStatus] = useState("Pending");
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const statusMap = {
    Pending: "pending",
    Completed: "imported"
  };

  const currentStatus = statusMap[selectedStatus];

  const totalCountForStatus =
    currentStatus === "pending"
      ? pending_requests
      : currentStatus === "imported"
        ? completed_requests
        : total_count;

  useEffect(() => {
    dispatch(
      actions.fetchRosterRequests({
        page: 1,
        limit: pagination?.limit || 10,
        status: currentStatus
      })
    );
  }, [dispatch, actions, pagination?.limit, currentStatus]);

  const statusMenuItems = [
    { label: "Pending", count: pending_requests },
    { label: "Completed", count: completed_requests }
  ];

  const handleStatusSelect = (item) => setSelectedStatus(item.label);
  const handleEdit = (row) => {
    setSelectedRow({ ...row });
    setShowEditModal(true);
  };
  const handleCloseModal = () => {
    setSelectedRow(null);
    setShowEditModal(false);
  };

  return (
    <>
      <CommonDashboardWrapper>
        <h1 className="common-heading">
          Roster Import Requests - Talent Agency
        </h1>

        <CardFlexWrapperStyles>
          <CardWrapperStyles>
            <div className="card-list">
              <DotOutlineFillIcon color="#F5A000" />
              <span className="card-title">Pending Requests</span>
            </div>

            {initialLoading ? (
              <SkeletonLoader width="40px" />
            ) : (
              <p className="card-count">{pending_requests}</p>
            )}
          </CardWrapperStyles>

          <CardWrapperStyles>
            <div className="card-list">
              <DotOutlineFillIcon color="#009336" />
              <span className="card-title">Completed Requests</span>
            </div>

            {initialLoading ? (
              <SkeletonLoader width="40px" />
            ) : (
              <p className="card-count">{completed_requests}</p>
            )}
          </CardWrapperStyles>
        </CardFlexWrapperStyles>
      </CommonDashboardWrapper>

      <TableWrapperStyles>
        <PillButtons
          placeholderText="Status"
          mainLabelText={selectedStatus}
          rightIcon={<Icon component={CaretDownIcon} />}
          menuItems={statusMenuItems}
          onSelect={handleStatusSelect}
          size="M"
          maxWidth="144px"
        />

        <CommonTable
          data={rosters}
          loading={loading}
          initialLoading={initialLoading}
          columns={columns(handleEdit)}
          page={pagination?.page || 1}
          limit={pagination?.limit || 10}
          total_count={totalCountForStatus}
          onPageChange={(newPage) =>
            dispatch(
              actions.fetchRosterRequests({
                page: newPage,
                limit: pagination?.limit || 10,
                status: currentStatus
              })
            )
          }
        />
      </TableWrapperStyles>

      <UpdateRosterStatusModal
        show={showEditModal}
        onHide={handleCloseModal}
        rowData={selectedRow}
        currentStatus={currentStatus}
      />
    </>
  );
};

export default TalentUploadRequest;
